export default __webpack_public_path__ + "static/media/meals-and-hands.982016cb.png";